import { vueErrorHandler } from "./vue-error-handler.ts";

export async function loadCookieConsentSafely(
  load: () => Promise<void>,
): Promise<void> {
  try {
    await load();
  } catch (error) {
    // A full-page navigation can cancel the deferred CSS and module imports.
    // Report startup failures without leaving an unhandled promise rejection.
    vueErrorHandler(error, null, "Cookie consent initialization");
  }
}
